import { cn } from "@/utils/cn"

// ─── Helpers ────────────────────────────────────────────────────────────────

export function fieldClass(error?: string, isRequired?: boolean) {
  return cn(
    'w-full min-h-[44px] rounded-lg border bg-[var(--glass-bg)] py-2.5 pl-3 pr-10 text-sm text-text-primary outline-none transition-colors placeholder:text-text-muted focus:border-accent',
    error
      ? 'border-red-500/50 focus:border-red-500'
      : isRequired
        ? 'border-[var(--glass-border)] border-l-2 border-l-amber-500/80 focus:border-accent'
        : 'border-[var(--glass-border)]'
  )
}

export function FormField({
  id,
  label,
  required,
  error,
  children,
}: {
  id?: string
  label: string
  required?: boolean
  error?: string
  children: React.ReactNode
}) {
  return (
    <div className="flex flex-col gap-1.5 w-full">
      <div className="flex items-center justify-between">
        <label htmlFor={id} className="text-[11px] text-text-muted font-bold uppercase tracking-wider cursor-pointer">
          {label}
          {required && <span className="text-amber-500 ml-0.5">*</span>}
        </label>
        {required && (
          <span className="text-[9px] font-black text-amber-500/90 uppercase tracking-widest bg-amber-500/10 px-1.5 py-0.5 rounded border border-amber-500/20 select-none">
            Obrigatório
          </span>
        )}
      </div>
      {children}
      {error && (
        <p className="text-red-400 text-xs mt-0.5">{error}</p>
      )}
    </div>
  )
}
